export default function ProgressBar({ value = 0, label, testId, size = "md" }) {
    const h = size === "sm" ? "h-1" : size === "lg" ? "h-2" : "h-1.5";
    return (
        <div data-testid={testId}>
            {label && (
                <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.15em] text-ink-400 font-mono mb-1.5">
                    <span>{label}</span>
                    <span className="text-ink-700">{value}%</span>
                </div>
            )}
            <div className={`w-full ${h} bg-ink-200 rounded-full overflow-hidden`}>
                <div
                    className="h-full bg-haevn-700 transition-all duration-500"
                    style={{ width: `${Math.max(0, Math.min(100, value))}%` }}
                />
            </div>
        </div>
    );
}
